import { API_URL } from "@/shared/config/api";
import { getAuthHeaders } from "@/shared/config/api";
import { NOTIFICATION_ENDPOINTS } from "@/constants/api.notifications";

export type PushClientId = "accueilv2" | "fronthagd";

export type PushSubscriptionJson = {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
  expirationTime?: number | null;
};

/**
 * Enregistre ou met à jour un abonnement Web Push côté backend.
 */
export async function savePushSubscription(
  token: string,
  buildingId: number,
  subscription: PushSubscriptionJson,
  client: PushClientId,
): Promise<void> {
  const url = `${API_URL}${NOTIFICATION_ENDPOINTS.PUSH_SUBSCRIPTION(buildingId)}`;
  const res = await fetch(url, {
    method: "POST",
    headers: getAuthHeaders(token),
    body: JSON.stringify({
      subscription,
      client,
    }),
  });
  if (!res.ok) {
    throw new Error(`PUSH_SUBSCRIPTION_HTTP_${res.status}`);
  }
}
